<template>
  <div>
    <transition-group :css="false" @enter="enter" @afterEnter="afterEnter" @leave="leave" class="tag-wrapper">
      <template v-for="(livingOption, index) in activeLivingOptions" :data-index="index" tag="div">
        <template v-if="livingOption.showOnMap">
          <tag-basic
            v-for="marker in livingOption.markers"
            v-bind="livingOption.marker"
            :class="{ 'tag-basic--sold-out': isSoldOut(livingOption) }"
            :key="livingOption._id + '_tag'"
            :pos="{
              x: marker.x,
              y: marker.y,
            }"
            :show-sold-label="showSoldLabel(livingOption)"
            :label="livingOption.displayName"
            :filtered="livingOption.filtered"
            @click.native="navigateToLivingOption(livingOption)"
          />
        </template>

        <template v-if="livingOption.showOnMap">
          <polygon-shape v-for="polygon in livingOption.polygons" :class="{ 'polygon-overlay--sold-out': isSoldOut(livingOption) }" :key="polygon._id + '_polygon'" :polygon="polygon" :filtered="livingOption.filtered" @click.native="navigateToLivingOption(livingOption)" />
        </template>
      </template>
    </transition-group>
  </div>
</template>
<script>
import PolygonShape from "@/components/PolygonShape";
import TagBasic from "@/components/TagBasic";
import { bus } from "../main";
import _ from "lodash";
import { buildLivingOptionPath, buildSubsectionPath } from "@/utils/livingRoute";

export default {
  props: ["living-options"],

  components: { PolygonShape, TagBasic },

  data() {
    return {
      activeLivingOptions: [],
    };
  },

  computed: {
    config() {
      return this.$store.state.newConfig;
    },
  },

  watch: {
    livingOptions(newLivingOptions, oldLivingOptions) {
      if (!_.isEqual(oldLivingOptions, newLivingOptions)) {
        if (oldLivingOptions.length) {
          this.activeLivingOptions = [];
        }

        if (newLivingOptions.length) {
          this.$store.commit("addAnimationToQueue", "LivingOptionTags");
        }
      }
    },
  },

  mounted() {
    bus.$on("animateLivingOptionTags", () => {
      if (!_.isEqual(this.activeLivingOptions, this.livingOptions)) {
        this.activeLivingOptions = this.livingOptions;
      } else {
        bus.$emit("finishedAnimation", "LivingOptionTags");
      }
    });
  },

  methods: {
    isSoldOut(livingOption) {
      return livingOption.availablePropertiesCount === 0 || livingOption.isSoldOut;
    },

    showSoldLabel(livingOption) {
      return this.config.general && this.config.general.showSoldLabel && this.isSoldOut(livingOption);
    },

    navigateToLivingOption(livingOption) {
      const isSoldOut = this.isSoldOut(livingOption);
      const canInteract = this.config.general && this.config.general.canInteractSoldLivingoptions;

      if (isSoldOut && !canInteract) {
        return;
      }

      if (this.config.skipOnlyChildSubsections && livingOption.subsections.length === 1) {
        this.$router.push(buildSubsectionPath(this.$route, livingOption._id, livingOption.subsections[0]._id, `?activeSubsectionId=${livingOption.subsections[0]._id}`));
      } else {
        this.$router.push(buildLivingOptionPath(this.$route, livingOption._id));
      }
    },

    enter(el, done) {
      const tagType = el.getAttribute("data-type");

      this.animationSpeed = 100;

      if (tagType === "basic") {
        this.animationSpeed = 50;
      }

      setTimeout(() => {
        el.classList.add("enter");
        done();
      }, (parseInt(this.delayIndex++) + 1) * this.animationSpeed);
    },

    afterEnter(el) {
      if (parseInt(el.dataset.index) + 1 === this.activeLivingOptions.length) {
        bus.$emit("finishedAnimation", "LivingOptionTags");
        this.delayIndex = 0;
      }
    },

    leave(el) {
      el.classList.add("leave");
      el.classList.remove("enter");
    },
  },
};
</script>
<style lang="scss" scoped>
.tag-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: var(--tag-z-index);

  .layout-switched & {
    top: 10rem;
  }
}
</style>
